import { newE2EPage } from "@stencil/core/testing";

describe("ux-icon-library", () => {
    xit("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-icon-library>
            </ux-icon-library>
        `);
        await page.waitForChanges();
        const el = await page.find("ux-icon-library");
        expect(el).toHaveClass("hydrated");
    });

    xit("should render the relevant sorting/searching elements", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-icon-library>
            </ux-icon-library>
        `);
        await page.waitForChanges();
        const el = await page.find("ux-icon-library");
        const searchInput = await page.find("ux-input-field");
        const dropdowns = await page.findAll("ux-dropdown");
        expect(searchInput).toHaveClass("hydrated");
        expect(dropdowns.length).toBe(3);
        expect(dropdowns[2]).toHaveClass("hydrated");
        expect(el).toHaveClass("hydrated");
    });
});
